/* eslint-disable camelcase */
import fetchCustomerLendingProfile from 'Utils/httpClients/fetchCustomerLendingProfile';
import { AxiosError, AxiosResponse } from 'axios';
import { LoggerFactory, DOMAIN } from 'Services/Logger';

const Logger = LoggerFactory.getLogger(DOMAIN.CUSTOMER_LENDING_PROFILE);
let isListenerOn = false;

export interface CustomerLendingProfileSettings {
  has_an_active_purchase_on_amazon: boolean;
}

const getCustomerLendingProfileSettings = async (): Promise<CustomerLendingProfileSettings> => {
  try {
    const response = await fetchCustomerLendingProfile(
      '/customer_lending_profile/api/v1/settings',
      'GET',
    ) as AxiosResponse<CustomerLendingProfileSettings>;

    return response.data;
  } catch (error) {
    if ((error as AxiosError).response?.status !== 401) {
      Logger.error('Error getting Customer Lending Profile settings', DOMAIN.CUSTOMER_LENDING_PROFILE, { error });
    }

    return Promise.reject(error);
  }
};

const storeCustomerLendingProfileSettings = async (): Promise<CustomerLendingProfileSettings> => {
  const settings = await getCustomerLendingProfileSettings();
  localStorage.setItem(
    'HAS_AN_ACTIVE_PURCHASE_ON_AMAZON',
    settings.has_an_active_purchase_on_amazon.toString(),
  );

  return settings;
};

const refreshCustomerLendingProfileSettingsOnWindowFocus = () => {
  if (!isListenerOn) {
    storeCustomerLendingProfileSettings();
    window.addEventListener('focus', storeCustomerLendingProfileSettings);

    isListenerOn = true;
  }
};

export {
  refreshCustomerLendingProfileSettingsOnWindowFocus,
  storeCustomerLendingProfileSettings,
};
